/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
import { useRouter } from 'next/router'
import { getPcekZone } from '@entities/user'
import { FetchQRStatus, getStatusInfo } from '@entities/payment'
import { parseAmount } from '@shared/lib'
import { pennyToRubles } from '@shared/lib/money'
import { useToast } from '@shared/lib/toast'
import { ERROR_MESSAGE_CHECK, reqHeaders } from '@shared/config'
import { dboPrintFormsApi } from '@root/api/api'
import { JsonNode } from '@root/api/ump-dboPrintForms'
import { OperationDetailsRs } from '@root/api/ump-ewallet'
import { getQrBaseAmount } from './getQrBaseAmount'
import { getQrFee } from './getQrFee'
import { getOperationDetailsBaseAmount } from './getOperationDetailsBaseAmount'
import { getOperationDetailsFee } from './getOperationDetailsFee'

interface useGetPdfArgs {
  payStatus: string
  receiptData?: Record<string, unknown>[]
  qrStatusData?: FetchQRStatus
  formattedDate?: string
  operationDetails?: OperationDetailsRs
}

export const useGetPdf = ({ payStatus, receiptData, qrStatusData, formattedDate, operationDetails }: useGetPdfArgs) => {
  const zone = getPcekZone()

  const router = useRouter()
  const { toast } = useToast()

  const isNonTopUpService = router.query.voucher === 'true'
  const isTopUpWithPercentFeeService = router.query.topup === 'true'

  const isNonTopUpServiceDenomation = Boolean(
    (isNonTopUpService && !operationDetails) || (isNonTopUpService && operationDetails)
  )

  const isCardPayment = operationDetails?.is3dsPerformed || operationDetails?.isCvcProvided

  const handleGetPdf = async () => {
    const serviceName = (receiptData?.find((item) => item.key === 'Услуга по переводу денежных средств')?.value ||
      '') as string

    const isPubg = serviceName.toLowerCase().includes('pubg')

    try {
      const params = {
        date: formattedDate,
        total: !operationDetails
          ? `${pennyToRubles(qrStatusData?.amount?.total ?? '0')} ₽`
          : `${parseAmount(operationDetails?.amount?.total ?? '0')} ₽`,
        state: getStatusInfo(payStatus).status,
        listParams: !operationDetails
          ? [
              ...(receiptData as Record<string, unknown>[]),
              {
                key: 'Сумма платежа',
                value: `${pennyToRubles(
                  getQrBaseAmount(qrStatusData, isPubg, isTopUpWithPercentFeeService, isNonTopUpServiceDenomation)
                )} ₽`,
              },
              {
                key: 'Комиссия',
                value: `${pennyToRubles(
                  getQrFee(qrStatusData, isPubg, isTopUpWithPercentFeeService, isNonTopUpServiceDenomation)
                )} ₽`,
              },
            ]
          : [
              ...(receiptData as Record<string, unknown>[]),
              {
                key: 'Сумма платежа',
                value: `${parseAmount(
                  getOperationDetailsBaseAmount(
                    operationDetails,
                    isCardPayment,
                    isPubg,
                    isTopUpWithPercentFeeService,
                    isNonTopUpServiceDenomation
                  )
                )} ₽`,
              },
              {
                key: 'Комиссия',
                value: `${parseAmount(
                  getOperationDetailsFee(
                    operationDetails,
                    isCardPayment,
                    isPubg,
                    isTopUpWithPercentFeeService,
                    isNonTopUpServiceDenomation
                  )
                )} ₽`,
              },
            ],
      }

      const requestConfig = {
        docType: 'pdf',
        template: 'universal_payment_receipt_lws',
        data: params as JsonNode,
      }

      const { data } = await (zone === 'b'
        ? dboPrintFormsApi.genPrintFormAuth(zone, 'v1', requestConfig, { headers: { ...reqHeaders } })
        : dboPrintFormsApi.genPrintForm(zone, 'v1', requestConfig, { headers: { ...reqHeaders } }))

      return data
    } catch (e) {
      toast({ variant: 'error', description: ERROR_MESSAGE_CHECK })
    }
  }

  return { handleGetPdf }
}
